import React, { useEffect, useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import { useSelector } from "react-redux";
import { fetchProjects } from "../../redux/ducks/project";
import useStatusThunk from "../../hook/useStatusThunk";
import useAuthEffect from "../../hook/useAuthEffect";
import Projects from "../../components/dumb/tables/Projects";
import { mapData } from "../../helpers/mapRow";

const ProjectsRoute = () => {

    const projects = useSelector(state => state.project.projects);
    const [rows, setRows] = useState([]);
    const [disptatchFetchProjects, status, error] = useStatusThunk(fetchProjects);

    useAuthEffect(() => disptatchFetchProjects());

    useEffect(() => {
        if (status == "success") setRows(mapData(projects));
    }, [status]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="projects" />
            </div>

            <div className="column column--primary">
                <Projects rows={rows} />
            </div>
        </div>
    )
}

export default ProjectsRoute;